import {
  HttpErrorResponse,
  HttpEvent,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import {
  EMPTY,
  Observable,
  catchError,
  map,
  switchMap,
  throwError,
} from 'rxjs';
import { AuthClient } from './auth-client';
import { createLoginPageUrl } from './utils';

/**
 * AuthInterceptor はバックエンドAPIと通信する際の認証情報についての処理を行う。
 *
 *
 * - 認証トークンをリクエストヘッダーに付与する
 * - 401 エラーがレスポンスされた場合にはログイン画面へリダイレクトする
 *
 */
export const authInterceptor: HttpInterceptorFn = (
  req,
  next,
): Observable<HttpEvent<unknown>> => {
  const auth = inject(AuthClient);

  return auth.fetchAccessToken().pipe(
    // Setup request
    map((accessToken) => {
      if (accessToken) {
        return req.clone({
          setHeaders: { Authorization: `Bearer ${accessToken}` },
        });
      }
      return req;
    }),
    // Send request
    switchMap((req) => next(req)),
    // Handle response
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        // ログアウトしてログイン画面へ遷移する。
        auth.logout({ returnTo: createLoginPageUrl(window.location.href) });
        return EMPTY;
      }
      return throwError(() => err);
    }),
  );
};
